/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DeviceType, useDevice } from '@squiz/dxp-console-support';
import React from 'react';

/**
 * The banner for the Login screen.
 */
export const LoginBanner = (): JSX.Element => {
  const deviceType = useDevice();
  const isDesktop = deviceType === DeviceType.desktop;

  const bannerImage = isDesktop ? (
    <img
      alt="Squiz Digital Experience Platform"
      className="user-management-banner__login-logo"
      src="/Assets/signin/logo-signin-desktop.svg"
    />
  ) : (
    <img
      alt="Squiz Digital Experience Platform"
      className="user-management-banner__image"
      src="/Assets/signin/logo-signin-mobile.svg"
    />
  );

  return <div className="user-management-banner">{bannerImage}</div>;
};
